import PropTypes from 'prop-types';
import {Icon} from 'semantic-ui-react';

function AddIcon(props) {
  return (
    <Icon.Group size={props.size} className={props.className}>
      <Icon name={props.name}/>
      <Icon inverted corner='bottom left' name='add'/>
    </Icon.Group>
  );
}

AddIcon.propTypes = {
  name: PropTypes.string,
  size: PropTypes.oneOf([
    'mini', 'tiny', 'small', 'large', 'big', 'huge', 'massive'
  ])
};

export default AddIcon;
